import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../../../services/common';
import { Subject, takeUntil } from 'rxjs';
import { SalesService } from '../../sales.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-client-agent-trans',
  templateUrl: './client-agent-trans.component.html',
  styleUrl: './client-agent-trans.component.scss'
})
export class ClientAgentTransComponent implements OnInit {
  private destroy$ = new Subject<void>();
  expandedRow: number | null = null;
  expandedClientRow: number | null = null;
  sortField: string = 'agentName';
  sortDirection: 'asc' | 'desc' = 'asc';
  agentId: any
  selectProjectId: any

  saleList: any;
  saleReportRequest: any
  projectSummary = {
    totalBooked: 0,
    totalAllotments: 0,
    soldValue: 0,
    receivedAmount: 0,
    balanceAmount: 0
  };

  constructor(public commonService: CommonService, private saleService: SalesService, private route: ActivatedRoute,) { }

  ngOnInit(): void {
    this.agentId = this.route.snapshot.queryParams["agentid"];
    this.selectProjectId = this.route.snapshot.queryParams["projectId"];


    this.saleReportRequest = {
      "ReportFrequency": 'daily',
    }

    if (this.agentId != null && this.agentId != 0)
      this.saleReportRequest.agentId = [Number.parseInt(this.agentId)]

    if (this.selectProjectId != null && this.selectProjectId != 0)
      this.saleReportRequest.projectId = [Number.parseInt(this.selectProjectId)]

    //if project id not came in url then it will fetch from subsriber(selected project from local storage)
    //otherwise will fetch data for project in url
    if (!this.selectProjectId)
      this.getClientSaleData();
    else
      this.getSaleData(this.selectProjectId)


    // Process to populate tree nodes and project summary
    // this.projectSummary = {
    //   totalBooked: project.totalBooked,
    //   totalAllotments: project.totalAllotments,
    //   soldValue: project.soldValue,
    //   receivedAmount: project.receivedAmount,
    //   balanceAmount: project.soldValue - project.receivedAmount
    // };
  }


  getClientSaleData() {
    this.commonService.selectedProjects$
      .pipe(takeUntil(this.destroy$)).subscribe((selectedProject: any) => {

        //project ids has tp go in array as for admin view we may need report for all in single view
        this.saleReportRequest.projectId = [selectedProject?.id]
        this.getSaleData(selectedProject?.id)
      })
  }

  getSaleData(projectId: any) {
    this.saleService.getClientWiseSale(this.saleReportRequest).subscribe(res => {
      if (res != null && res?.result?.length > 0) {
        this.saleList = res?.result;
        //bydefault sorting on agent name
        this.sortDirection = 'desc';
        this.sortData('agentName', 'source');
      }
    })
  }

  toggleRow(index: number) {
    this.expandedRow = this.expandedRow === index ? null : index;
    this.sortData('clientName', 'client', index);
  }

  toggleClientRow(index: number) {
    this.expandedClientRow = this.expandedClientRow === index ? null : index;
  }

  sortData(field: string, level: 'source' | 'client' | 'transaction', parentIndex?: number, clientIndex?: number) {
    this.sortDirection = (this.sortField === field && this.sortDirection === 'asc') ? 'desc' : 'asc';
    this.sortField = field;

    const compare = (a: any, b: any) => {
      const valueA = a[field] ?? '';
      const valueB = b[field] ?? '';
      if (typeof valueA === 'number' && typeof valueB === 'number') {
        return this.sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
      }
      return this.sortDirection === 'asc'
        ? String(valueA).localeCompare(String(valueB))
        : String(valueB).localeCompare(String(valueA));
    };

    if (level === 'source') {
      this.saleList[0].sources.sort(compare);
    } else if (level === 'client' && parentIndex !== undefined) {
      this.saleList[0].sources[parentIndex].clients.sort(compare);
    } else if (level === 'transaction' && parentIndex !== undefined && clientIndex !== undefined) {
      this.saleList[0].sources[parentIndex].clients[clientIndex].transactions.sort(compare);
    }
  }
}
